module.exports = __webpack_public_path__ + "static/media/plantPal2_11.9a58ec83.png";